<!-- Pdf View Modal -->
<button id="toggleReceiptView-{{key || ''}}" [attr.data-target]="'#receiptViewModal-' + (key || '')" data-toggle="modal" class="btn btn-sm d-none"></button>
<div id="receiptViewModal-{{key || ''}}" class="modal fade" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="viewReceipt">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Receipt</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="done($event)">
                    <span>&times;</span>
                </button>
            </div>
            <div class="modal-body">
                @if (pdf) {
                    <object type="application/pdf" [data]="pdf" width="100%" height="100%"></object>
                }
                @else {
                    <div class="waiting">
                        <div class="spinner-grow text-primary" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div>
                }
            </div>
            <div class="modal-footer">
                @if (receipt && receipt.id) {
                    @if (refunding) {
                        <form [formGroup]="form" id="refund-form" class="form-inline">
                            <currency-input [id]="'receipt-refund'" [control]="form.get('refund')" (committed)="processRefund($event)"></currency-input>
                            <input type="text" class="form-control form-control-sm" id="reason" formControlName="reason" placeholder="reason" maxlength="255" />
                            <button type="submit" class="btn btn-sm btn-primary" (click)="processRefund($event)">Refund</button>
                        </form>
                    }
                    
                    @if (voiding) {
                        <form [formGroup]="voidForm" id="void-form" class="form-inline">
                            <input type="date" class="form-control form-control-sm" id="voided" formControlName="voided" />
                            <input type="text" class="form-control form-control-sm" id="reason" formControlName="reason" placeholder="reason" maxlength="255" />
                            <button type="submit" class="btn btn-sm btn-danger" (click)="processVoid($event)">Void</button>
                        </form>
                    }
                    
                    @if (returning) {
                        <form [formGroup]="returnForm" id="return-form" class="form-inline">
                            <input type="date" class="form-control form-control-sm" id="returned" formControlName="returned" />
                            <select class="form-control form-control-sm" formControlName="code">
                                @for (code of codes; track code.code) {
                                    <option [value]="code.code">{{code.code}} &ndash; {{code.reason}}</option>
                                }
                            </select>
                            <input type="text" class="form-control form-control-sm" id="reason" formControlName="reason" placeholder="reason" maxlength="255" />
                            <button type="submit" class="btn btn-sm btn-danger" (click)="processReturn($event)">Return</button>
                        </form>
                    }

                    @if (!refunding && !returning && !voiding && editable) {
                        @if (card || cash) {
                            <button type="button" class="btn btn-sm btn-link" (click)="initRefund($event)"><div class="btn-icon"><span class="material-icons">undo</span> <span>refund</span></div></button>
                        }
                        @if (check || draft) {
                            <button type="button" class="btn btn-sm btn-link" (click)="initReturn($event)"><div class="btn-icon"><span class="material-icons text-danger">undo</span> <span class="text-danger">return (bounce)</span></div></button>
                            <button type="button" class="btn btn-sm btn-link" (click)="initVoid($event)"><div class="btn-icon"><span class="material-icons text-danger">cancel</span> <span class="text-danger">void</span></div></button>
                        }
                    }
                }
            </div>
        </div>
    </div>
</div>